import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { ProductGrid } from '../components/ProductGrid';
import { motion } from 'framer-motion';
export function OTCProducts() {
  const {
    storeId
  } = useParams();
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get('search') || '';
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="bg-white" data-id="element-508" data-mp="1gxa7bo27rarm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 md:pt-20" data-id="element-509" data-mp="o83b4vq8ex9j">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mb-4 uppercase tracking-tighter" data-id="element-510" data-mp="o5yx3kymchvj">
          {searchQuery ? `Search Results` : `Over-the-Counter Products`}
        </h1>
        <p className="text-base sm:text-lg text-slate-600 mb-4 max-w-3xl" data-id="element-511" data-mp="y469rrlvkdrq">
          {searchQuery ? `Showing results for "${searchQuery}"` : `Browse our full selection of quality health and wellness products.`}
        </p>
      </div>
      <ProductGrid storeId={storeId} searchQuery={searchQuery} data-id="element-512" data-mp="1v1bbjihs5cgs" />
    </motion.div>;
}